<template>
    <card-info-horizontal-slider title="Discover peoples">
        <div class="slide-item" v-for="(n, i) in items" :key="'discover-'+i">
            <card-user name="Aneesh" link="/aneesh/" block></card-user>
        </div>
    </card-info-horizontal-slider>
</template>
<script>
export default {
    data: () => ({
        items: 20
    })
}
</script>